import MixByType from './MixByType.js';
import {
    PATTERN_SWITCH,
    RESOLUTION_CHANGE,
    SEQUENCE_ROLL,
    DETERMINISTIC
} from './constants.js';

// represents a quantized mapping of step -> event
// used in PATTERN_SWITCH_EVENT and SEQUENCE_ROLL_EVENT
class DeterministicMixByType extends MixByType {
    constructor(type, defaultValue, subSequence) {
        super(type, subSequence);

        this.defaultValue = defaultValue;
        this.heldEvent = undefined;
        this.currentEvent = defaultValue;

        this.cache = {};
    }

    getMixType() {
        return DETERMINISTIC;
    }

    restart(isLoop=false) {
        super.restart();
        this.cache = {};
        if (!isLoop) {
            this.heldEvent = undefined;
        }
        this.currentEvent = this.defaultValue;
    }

    clear() {
        super.clear();
        this.cache = {};
    }

    // when user explicitly changes the value w/o it being in
    // record mode, we keep the value at this, until a new
    // event is added
    holdEvent(event, trackStep) {
        this.heldEvent = event;
    }
  
    getPreviousEvent(event, useEquals=true, useCounter=false) {
        return super.getPreviousEvent(event, useEquals, useCounter) ||
            this.defaultValue;
    }

    // returns the values between two steps
    getValuesBetweenSteps(step1, step2) {
        let values = [];
        let lastValue = undefined;
        for (let i=step1; i < step2; i++) {
            let event = this.getValue(i, false, false);
            let value = event.getValue();
            if (this.type === RESOLUTION_CHANGE) {
                if (lastValue === undefined ||
                    !value.equals(lastValue)) {
                    values.push({
                        step: i,
                        value: value,
                        event: event,
                    });
                }
            } else if (value !== lastValue) {
                values.push({
                    step: i,
                    value: value,
                    event: event,
                });
            } 

            lastValue = value;
        }

        for (let i=0; i < values.length; i++) {
            if (values[i + 1] === undefined) {
                values[i].duration = step2 - values[i].step;
            } else {
                values[i].duration = values[i + 1].step - values[i].step;
            }
            values[i].event.duration = values[i].duration;
        }

        return values;
    }

    getValue(step, useCounter=true) {
        return this.getEvent(step, useCounter)
            .getValue();
    }

    // to be used only when getting values to sequence
    // because it has the side effect of updating a counter
    // which is used to quickly retrieve the values
    getEvent(step, useCounter=true) {
        if (this.heldEvent) {
            return this.heldEvent;
        }

        if (step in this.cache) {
            return this.cache[step];
        }

        if (step == 0 && useCounter) {
            this.restart();
        }

        let i = useCounter ? this.counter : 0;
        let event = undefined;

        for (; i < this.events.length; i++) {
            if (this.events[i].step > step) {
                break;
            }
            if (this.heldEvent === undefined ||
                this.events[i].step === step) {
                event = this.events[i];
            }
        }

        if (useCounter) {
            this.counter = Math.max(0, i - 1);
        }

        if (event !== undefined) {
            // store this event as the current value
            this.currentEvent = event;
            this.heldEvent = undefined;
        } else {
            this.cache[step] = this.currentEvent
            return this.currentEvent;
                
        }

        this.cache[step] = event;
        return event;
    }
}

export default DeterministicMixByType;
